const format = (value, { decimalLength = 2, wholePartLength = 3, sectionsDelimiter = ' ', decimalDelimiter = ',' } = {}) => {
  let re = '\\d(?=(\\d{' + wholePartLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')'
  let num = value.toFixed(decimalLength)

  return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(re, 'g'), '$&' + sectionsDelimiter)
}

export default {
  install (Vue) {
    Vue.filter('numberFormat', function (value, { rounded = false } = {}) {
      return rounded ? format(Math.round(value), { decimalLength: 0 }) : format(value)
    })
  }
}
